import { useCallback, useState } from 'react';

interface Props {
  defaultValue?: boolean;
}

export default function useOpen(props?: Props) {
  const [value, setValue] = useState(!!props?.defaultValue);

  const handleSwitch = useCallback(() => setValue((value) => !value), []);
  const handleOpen = useCallback(() => setValue(true), []);
  const handleClose = useCallback(() => setValue(false), []);

  return { value, setValue, handleSwitch, handleOpen, handleClose };
}
